'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colors = require('./styles/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var type = _ref.type,
        style = _ref.style;


    style = _extends({
        fill: _colors.silver
    }, style);

    var path = null;
    var size = 16;

    switch (type) {
        case 'chevron-down':
            path = _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M3,9.98966968 L4.02439024,11 L9,6.0926813 L9,6 L9,5.9073187 L4.02439024,1 L3,2.01033032 L7.04519058,6 L3,9.98966968 Z', transform: 'rotate(90, 6, 6)' });
            size = 12;
            break;
        case 'chevron-right':
            path = _react2.default.createElement('path', { d: 'M3,9.98966968 L4.02439024,11 L9,6.0926813 L9,6 L9,5.9073187 L4.02439024,1 L3,2.01033032 L7.04519058,6 L3,9.98966968 Z', transform: 'rotate(0, 6, 6)' });
            size = 12;
            break;
        case 'close':
            path = _react2.default.createElement('polygon', { points: '9.99282117 1 5.99946427 4.99228544 2.00610736 1 1 2.00717883 4.99228544 6.00053573 1 9.99282117 2.00610736 11 5.99946427 7.00664309 9.99282117 11 11 9.99282117 7.00771456 6.00053573 11 2.00717883' });
            size = 12;
            break;
        case 'plus-sign':
            path = _react2.default.createElement('path', { d: 'M9,7 L9,2 L7,2 L7,7 L2,7 L2,9 L7,9 L7,14 L9,14 L9,9 L14,9 L14,7 L9,7 L9,7 Z' });
            break;
    }

    var viewBox = '0 0 ' + size + ' ' + size;
    return _react2.default.createElement(
        'svg',
        { style: style, width: size, height: size, viewBox: viewBox },
        path
    );
};
//# sourceMappingURL=Icon.js.map